module.exports = __webpack_public_path__ + "img/icon-letter-i.2d5ad67c.svg";